// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","footerContent":"Footer_footerContent__3Q8oJ"};